<template>
  <div>
    <section class="content-header" style="height: 50px;">
      <h1 style="float: left; padding-right: 10px;">{{ $root.title}}</h1>
    </section>
    <div class="box-body">
      <SettingsAdmin v-if="$root.isAdmin" :settingsData="settingsData"></SettingsAdmin>
      <SettingsDealer v-else :settingsData="settingsData"></SettingsDealer>
    </div>
    <footer class="footerSettings">
      <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancel"></va-button>
      <va-button :isBlock="false" theme="success" align="right" name="Save" @click.native="save" style="margin-right: 10px;"></va-button>
    </footer>
  </div>
</template>
<script>
  import SettingsAdmin from '../components/SettingsAdmin'
  import SettingsDealer from '../components/SettingsDealer'
  import VAButton from '../components/VAButton'
  import { db } from '../firebase'

  export default {
    name: 'settings',
    components: { 'va-button': VAButton, SettingsAdmin, SettingsDealer },
    data () {
      return {
        originData: null
      }
    },
    firebase: function () {
      let vm = this
      let settingsPath = 'Settings/'
      if (vm.$root.isAdmin) {
        settingsPath += 'Admin'
      } else {
        settingsPath += vm.$root.user['.key']
      }
      let settingsRef = db.ref(settingsPath)
      return {
        settingsData: {
          source: settingsRef,
          asObject: true,
          cancelCallback: function () { },
          readyCallback: function () {
            vm.originData = JSON.parse(JSON.stringify(vm.settingsData))
          }
        }
      }
    },
    created () {
      this.$root.title = 'Settings'
    },
    methods: {
      cancel () {
        this.settingsData = JSON.parse(JSON.stringify(this.originData))
      },
      save () {

      }
    }
  }
</script>
<style>
  .footerSettings{
    position: absolute;
    bottom: 0px;
    right: 0px;
    background-color: #ddd;
    width: 100%;
    vertical-align: central;
    padding: 15px;
  }
</style>




// WEBPACK FOOTER //
// Settings.vue?9f1838ec